import * as React from "react";
import { IToggleDot } from "./ToggleDot.types";

const ToggleDot = ({ isActive = false, handleSelect }: IToggleDot) => {
  const colorDot = isActive ? "bg-brand" : "bg-gray-3";
  return (
    <span
      className={`cursor-pointer size-[10px] ${colorDot} rounded-full`}
      onClick={handleSelect}
    />
  );
};

export default ToggleDot;
